/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查看支付渠道
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<payment.Codebook>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/channel`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
